<template>
  <v-app>

    <v-dialog
      v-model="scheduleCodeDialog"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{$t('Schedule Code')}}
        </v-card-title>

        <v-card-text class="mt-5">
          {{$t('Please Enter your schedule code and email below')}}

          <v-text-field
            v-model="scheduleCode"
            class="mt-1"
            :label="$t('Schedule Code')"
            outlined
          ></v-text-field>
          <v-text-field
            v-model="scheduleEmail"
            :label="$t('Email Address')"
            outlined
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="validatsubmiteCode"
          >
            {{$t('Submit')}}

          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog"
      scrollable
      max-width="520px"
    >
      <v-card>
        <v-card-title>Availabilities for {{selectedDate}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-alert
            class='mt-5'
            dense
            outlined
            type="info"
          >
            {{$t('Time shown in: America/Los_Angeles time zone')}}
          </v-alert>

          <v-list
            three-line
            :key='index'
            v-for='(item,index) in avaiableTimes'
          >
            <v-list-item :key="item.title">
              <v-list-item-avatar size='100'>
                <v-img :src="getGCPicture(item.gcID)"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{getGCName(item.gcID)}}</v-list-item-title>
                <v-list-item-subtitle>
                  <v-chip-group
                    active-class="success--text"
                    column
                  >
                    <v-chip
                      outlined
                      color='green'
                      v-for="(times,time) in item.data"
                      :key="time"
                      @click='selectedTime = times.time , selectedGC = item.gcID, step = 4,  dialog = false'
                    >
                      {{ $moment(times.time).format("hh:mm")}}
                    </v-chip>
                  </v-chip-group>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

        </v-card-text>
        <v-card-actions>
          <v-btn
            color="deep-purple lighten-2"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
    <v-dialog
      v-model="loadingDialog"
      persistent
      width="400"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text class='pt-3 pb-5'>
          {{$t('Please wait while we get the data for you.')}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-main>
      <v-container>
        <div class='ma-1'>
          <v-btn
            class='mr-2'
            @click='changeLocale("en")'
          >
            English
          </v-btn>
          <v-btn @click='changeLocale("es")'>
            Español
          </v-btn>
        </div>
        <br />
        <p style="text-align : center ; font-size : 18px;" class="mb-5">
          {{$t('Please complete the form below to schedule your telehealth video appointment with one of our certified genetic counselors. We look forward to meeting you. For more information about providers, cost, and what to expect from a genetic counseling appointment,')}} <a href="https://geneticsupportfoundation.org/schedule/#" target="_blank">{{$t('click here.')  }}</a>
        </p>
        <p style="text-align : center ; font-size : 18px;">
          {{ $t('Upload relevant medical records including results from any prior genetic testing  and a photo of your insurance card (front and back) if you would like us to bill your insurance for the genetic counseling visit.')}} <a href="https://geneticsupportfoundation.org/billing-insurance/" target="_blank">{{ $t("(Click here to learn more about insurance billing.)") }}</a>
        </p>
        <br />
        
        <v-stepper
          v-if="!scheduleCodePresent"
          v-model="currentStep"
          vertical
        >

          <v-stepper-step
            :complete="currentStep > 1"
            step="1"
          >
            {{$t('Welcome')}}
          </v-stepper-step>

          <v-stepper-content step="1">
            <v-row>
              <v-col cols="6">
                <v-hover v-slot="{ hover }">
                  <v-card
                    :elevation="hover ? 5 : 2"
                    style='cursor:pointer'
                    class="d-flex align-center ma-1"
                    @click='currentStep = 2'
                  >

                    <v-card-text class="font-weight-medium mb-5  text-center subtitle-1">

                      <p>
                        <v-icon
                          size='50'
                          color="green darken-2"
                        >
                          mdi-calendar
                        </v-icon>
                      </p>
                      {{$t('I would like to request an appointment')}}
                    </v-card-text>

                  </v-card>
                </v-hover>
              </v-col>
            
            </v-row>
          </v-stepper-content>

          <v-stepper-step
            :complete="currentStep > 1"
            step="2"
          >

            {{$t('Appointment Request Form')}}
          </v-stepper-step>

          <v-stepper-content step="2">
            <Form />

          </v-stepper-content>

          <v-stepper-step
            :complete="currentStep > 2"
            step="3"
          >

            {{$t('Form of Payment')}}

          </v-stepper-step>

          <v-stepper-content step="3">
            <PaymentV2 @onPaymentButtonClick='handlePaymentButtonClick' />
            <v-btn
              @click="currentStep = 2"
              text
            >
              {{$t('Back')}}
            </v-btn>
          </v-stepper-content>

          <v-stepper-step
            :complete="currentStep > 4"
            step="4"
          >
            {{$t('Payment Detail')}}

          </v-stepper-step>
          <v-stepper-content step="4">
            <PaymentDetail v-if='currentStep === 4' />

          </v-stepper-content>
          <v-stepper-step
            :complete="currentStep > 5"
            step="5"
          >
            {{$t('Confirmation')}}
          </v-stepper-step>

          <v-stepper-content step="5">
            <button
              class='gsfBtn'
              @click='submit()'
            >
              {{$t('Submit Request')}} >
            </button>
            <v-btn
              large
              @click="currentStep = 4"
              text
            >
              {{$t('Back')}}
            </v-btn>
          </v-stepper-content>

        </v-stepper>

        <transition name="fade">
          <TimePicker
            @back='backtohome'
            v-if='step === 3'
            @lastMonth='fetchDate'
            @nextMonth='fetchDate'
            @loadTime='fetchDate(true)'
          />
        </transition>
        <transition name="fade">
          <Confirmation
            @next='step = 5'
            @back='step = 3'
            v-if='step === 4'
          />
        </transition>
        <transition name="fade">
          <Payment
            @insurance='step = "6a"'
            @creditcard='step = "6b"'
            @back='step = 4'
            v-if='step === 5'
          />
        </transition>
        <transition name="fade">
          <InsuraceBilling
            @back='step = 5'
            v-if='step === "6a"'
            :language='language'
          />
        </transition>
      </v-container>

    </v-main>
  </v-app>
</template>

<script>
import Form from "../components/Form.vue";
import TimePicker from "../components/timePicker";
import Confirmation from "../components/Confirmation";
import Payment from "../components/Payment";
import InsuraceBilling from "../components/InsuraceBilling";
import { working_GC, Gc_pic_url } from "../utilities";
import { mapFields } from "vuex-map-fields";
import shortid from "shortid";
import PaymentV2 from "../components/p2.vue";
import PaymentDetail from "../components/PaymentDetail.vue";

export default {
  components: {
    Form,
    TimePicker,
    Confirmation,
    Payment,
    InsuraceBilling,
    PaymentV2,
    PaymentDetail,
  },

  methods: {
    changeLocale(locale) {
      this.language = locale;
    },
    backtohome() {
      this.step = 1;
      this.scheduleCodePresent = false;
      this.scheduleCodeDialog = false;
    },
    async submit() {
      this.loadingDialog = true;
      try {
        await this.$axios.post(
          "https://publicv2-rbt7xacjtq-uw.a.run.app/guestSubmit",
          this.form
        );
        for (const file of this.form.filesBase64) {
          await this.$axios.post(
            "https://publicv2-rbt7xacjtq-uw.a.run.app/guestUpload",
            {
              uploadID: this.uploadId,
              fileName: file.fileName,
              fileType: file.fileType,
              baseString: file.baseString,
            }
          );
        }

        alert(
          "Thank you for reaching out to Genetic Support Foundation. We have received your request for a genetic counseling appointment.  We are reviewing the information you provided and will respond back with next steps within  2 business days.  If you have questions, or need more urgent assistance, please contact us by phone at 1-844-743-6384. "
        );
        this.loadingDialog = false;
        //location.reload();
      } catch (e) {
        alert(
          this.$t(
            "It looks like you have already registered with Genetic Support Foundation. Please contact us by phone at 844-743-6384 to schedule an appointment."
          )
        );
        this.loadingDialog = false;
      }
    },
    handlePaymentButtonClick() {
      this.currentStep = 4;
    },
    async validatsubmiteCode() {
      this.loadingDialog = true;
      const r = await this.$axios.post(
        "https://us-central1-gsf-ehr.cloudfunctions.net/public/validateScheduleCode",
        {
          code: this.scheduleCode,
          email: this.scheduleEmail,
        }
      );
      this.loadingDialog = false;
      if (r.data.length > 0) {
        this.selectedStateID = r.data[0].stateId;
        this.form = r.data[0];
        this.form.timezone = {
          value: r.data[0].timezone,
          name: r.data[0].timezone,
        };
        this.step = 3;
        this.form.gender = r.data[0].sex;
        this.scheduleCodeDialog = false;
        this.scheduleCodePresent = true;
      }
    },
    getGCPicture(gcID) {
      return Gc_pic_url(gcID).pic;
    },
    getGCName(gcID) {
      return Gc_pic_url(gcID).name;
    },
    fetchDate(fetchTime) {
      let promises = [];
      let appt = this.allApptType.find((a) => a.id === this.selectedStateID);
      let workingGC = working_GC(this.form.reason);
      const filteredArray = workingGC.filter((value) =>
        appt.calendarIDs.includes(value)
      );
      this.loadingDialog = true;
      filteredArray.forEach((a) => {
        promises.push(
          fetchTime
            ? this.$axios.post(
                "https://us-central1-gsf-ehr.cloudfunctions.net/acuity/times",
                {
                  date: this.selectedDate,
                  appointmentTypeID: this.selectedStateID,
                  calendarID: a,
                }
              )
            : this.$axios.post(
                "https://us-central1-gsf-ehr.cloudfunctions.net/acuity/dates",
                {
                  timezone: this.form.timezone.value,
                  month: this.selectedMonth
                    ? this.selectedMonth
                    : this.$moment().format("yyyy-MM"),
                  appointmentTypeID: this.selectedStateID,
                  calendarID: a,
                }
              )
        );
      });

      fetchTime
        ? Promise.all(promises).then((values) => {
            this.loadingDialog = false;
            let temp = values.map((a) => {
              if (a.data.length > 0) {
                let postBody = JSON.parse(a.config.data);
                return {
                  gcID: postBody.calendarID,
                  data: a.data,
                };
              }
            });
            temp = temp.filter((n) => n);
            this.avaiableTimes = temp;
            this.dialog = true;
          })
        : (this.avaiableDates = []);
      Promise.all(promises).then((values) => {
        this.loadingDialog = false;
        let temp = values.map((a) => a.data);
        temp = Array.prototype.concat.apply([], temp);
        temp = temp.map((a) => a.date);
        temp = [...new Set(temp)];
        temp = temp.sort();
        for (var i = 0; i < temp.length; i++) {
          this.avaiableDates.push({
            name: "available",
            start: temp[i],
            color: "green",
            allDay: true,
          });
        }
      });
    },
  },
  async mounted() {
    const response = await this.$axios.get(
      "https://us-central1-gsf-ehr.cloudfunctions.net/acuity/availability"
    );
    this.allApptType = response.data;
    this.uploadId = shortid.generate();
  },
  computed: {
    ...mapFields([
      "language",
      "uploadId",
      "form",
      "allApptType",
      "selectedStateID",
      "avaiableDates",
      "avaiableTimes",
      "selectedMonth",
      "selectedDate",
      "selectedGC",
      "selectedTime",
      "doctorReferece",
      "currentStep",
    ]),
  },
  data() {
    return {
      scheduleCodePresent: false,
      scheduleEmail: null,
      scheduleCode: null,
      scheduleCodeDialog: false,
      dialog: false,
      loadingDialog: false,
      step: 1,
    };
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>